import React from 'react';
import PropTypes from 'prop-types';

import SeeErrorButton from "./components/SeeErrorButton";
import LogButton from "./components/LogButton";

ImportReportActions.propTypes = {
    importReport: PropTypes.object.isRequired,
};

function ImportReportActions({importReport}) {
    return (
        <div style={{display: 'flex', gap:'4px'}}>
            <SeeErrorButton importReport={importReport}/>
            <LogButton importReport={importReport} />
        </div>
    );
}

export default ImportReportActions;
